import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import ProducerProfileForm from "@/components/forms/ProducerProfileForm";
import OffersTab from "./producer/OffersTab";
import ApplicationsTab from "./producer/ApplicationsTab";
import SavedProfilesTab from "./producer/SavedProfilesTab";
import CreditsTab from "./producer/CreditsTab";
import BillingTab from "./producer/BillingTab";
import PendingRatingsTab from "@/components/ratings/PendingRatingsTab";
import MessagesTab from "@/components/messages/MessagesTab";

const TABS = ["offers", "applications", "saved", "credits", "billing", "profile", "ratings", "messages"];

export default function ProducerDashboardPage() {
  const { t } = useTranslation();
  const { tab = "offers" } = useParams();
  const navigate = useNavigate();

  return (
    <div className="max-w-6xl mx-auto px-6 sm:px-8 py-10 sm:py-14" data-testid="producer-dashboard-page">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold mb-8">{t("dashboard.producerDashboard")}</h1>
      <Tabs value={TABS.includes(tab) ? tab : "offers"} onValueChange={(v) => navigate(`/dashboard/producer/${v}`)}>
        <TabsList className="mb-8 flex-wrap h-auto rounded-xl">
          <TabsTrigger value="offers" data-testid="producer-tab-offers">{t("dashboard.tabOffers")}</TabsTrigger>
          <TabsTrigger value="applications" data-testid="producer-tab-applications">{t("dashboard.tabApplications")}</TabsTrigger>
          <TabsTrigger value="messages" data-testid="producer-tab-messages">{t("dashboard.tabMessages")}</TabsTrigger>
          <TabsTrigger value="saved" data-testid="producer-tab-saved">{t("dashboard.tabSavedProfiles")}</TabsTrigger>
          <TabsTrigger value="credits" data-testid="producer-tab-credits">{t("dashboard.tabCredits")}</TabsTrigger>
          <TabsTrigger value="billing" data-testid="producer-tab-billing">{t("dashboard.tabBilling")}</TabsTrigger>
          <TabsTrigger value="ratings" data-testid="producer-tab-ratings">{t("dashboard.tabRatings")}</TabsTrigger>
          <TabsTrigger value="profile" data-testid="producer-tab-profile">{t("producerProfile.title")}</TabsTrigger>
        </TabsList>
        <TabsContent value="offers"><OffersTab /></TabsContent>
        <TabsContent value="applications"><ApplicationsTab /></TabsContent>
        <TabsContent value="messages"><MessagesTab /></TabsContent>
        <TabsContent value="saved"><SavedProfilesTab /></TabsContent>
        <TabsContent value="credits"><CreditsTab /></TabsContent>
        <TabsContent value="billing"><BillingTab /></TabsContent>
        <TabsContent value="ratings"><PendingRatingsTab /></TabsContent>
        <TabsContent value="profile">
          <div className="bg-white rounded-2xl border border-black/5 shadow-[0_4px_24px_rgba(0,0,0,0.03)] p-6 sm:p-8">
            <ProducerProfileForm />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
